import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';

import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';

export function PlatformSettingsAudiPl() {
  return <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.AUDI_PL} />;
}
